import { handleActions, createAction } from "redux-actions";
import { axios, axiosWithoutHeaders } from "../cores/axiosWrapper";
import queryString from "../cores/queryString";
import { getRoleActionsAPI } from "@modules/apis/rolesManagement_v2";

function getAuditsAPI(stageId, apiEndpoint, projectId, params) {
    const headers = {
        stageId,
    };

    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/v2/audit-logs`, {
        params,
        headers,
    });
}

export function getAuditAPI(stageId, apiEndpoint, id, projectId) {
    const headers = {
        stageId,
    };

    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.get(`${apiEndpoint}/v2/audit-logs/${id}`, {
        headers,
    });
}

export function getAuditSearchKeysAPI(stageId, apiEndpoint, projectId) {
    const headers = {
        stageId,
    };

    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.get(`${apiEndpoint}/v2/audit-logs/search-keys`, {
        headers,
    });
}

const AUDITS_PENDING = "AUDITS_PENDING";
const AUDITS_FAILURE = "AUDITS_FAILURE";
const RESET_AUDITS_LOGS = "RESET_AUDITS_LOGS";
const GET_AUDITS_V2_FOR_LIST_SUCCESS = "GET_AUDITS_V2_FOR_LIST_SUCCESS";
const GET_AUDITS_V2_FOR_LIST_SUCCESS_TO_APPEND = "GET_AUDITS_V2_FOR_LIST_SUCCESS_TO_APPEND";
const GET_AUDITS_V2_FOR_DETAIL_SUCCESS = "GET_AUDITS_V2_FOR_DETAIL_SUCCESS";
const GET_AUDITS_V2_SEARCH_KEYS_SUCCESS = "GET_AUDITS_V2_SEARCH_KEYS_SUCCESS";
const GET_AUDITS_V2_ACTIONS_SUCCESS = "GET_AUDITS_V2_ACTIONS_SUCCESS";

const initialState = {
    pending: false,
    error: false,
    list: null,
    searchKeys: null,
    actions: null,
};

export const resetAuditLogs = createAction(RESET_AUDITS_LOGS);

export default handleActions(
    {
        [AUDITS_PENDING]: (state) => {
            return {
                ...state,
                pending: true,
                error: false,
            };
        },
        [AUDITS_FAILURE]: (state) => {
            return {
                ...state,
                pending: false,
                error: true,
            };
        },
        [RESET_AUDITS_LOGS]: (state) => {
            return {
                ...state,
                pending: false,
                error: false,
                list: null,
            };
        },
        [GET_AUDITS_V2_FOR_LIST_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                list: action.payload,
            };
        },
        [GET_AUDITS_V2_FOR_LIST_SUCCESS_TO_APPEND]: (state, action) => {
            let { data } = action.payload;

            return {
                ...state,
                pending: false,
                error: false,
                list: { results: state.list.results.concat(data.results), nextToken: data.nextToken },
                exclusiveStartKey: data.exclusiveStartKey,
            };
        },
        [GET_AUDITS_V2_FOR_DETAIL_SUCCESS]: (state, action) => {
            let { data } = action.payload;

            return {
                ...state,
                pending: false,
                error: false,
                item: data,
            };
        },
        [GET_AUDITS_V2_SEARCH_KEYS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            return {
                ...state,
                searchKeys: data,
            };
        },
        [GET_AUDITS_V2_ACTIONS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            return {
                ...state,
                actions: data,
            };
        },
    },
    initialState,
);

const generateAuditLogSubject = (action) => {
    const parseAction = (action) => {
        switch (action) {
            case "Create download link":
                return "Shared externally";
            case "Create":
                return "Shared internally";
            case "Download":
                return "Downloaded";
            default:
                return undefined;
        }
    };

    const parsedAction = parseAction(action);
    return parsedAction;
};
export const getAudits =
    ({ projectId, params }) =>
    (dispatch, getState) => {
        let { stage, auditsV2 } = getState();

        dispatch({ type: AUDITS_PENDING });
        return getAuditsAPI(stage.id, stage.endpoint, projectId, params)
            .then(async (response) => {
                const results = response.data?.results?.map((el) => ({
                    ...el,
                    subject: generateAuditLogSubject(el.action),
                }));
                if (!auditsV2.list) {
                    dispatch({
                        type: GET_AUDITS_V2_FOR_LIST_SUCCESS,
                        payload: { ...response.data, results },
                    });
                } else {
                    dispatch({
                        type: GET_AUDITS_V2_FOR_LIST_SUCCESS_TO_APPEND,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: AUDITS_FAILURE,
                });
            });
    };
export const getAudit =
    ({ projectId, id }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        return getAuditAPI(stage.id, stage.endpoint, id, projectId)
            .then((response) => {
                dispatch({
                    type: GET_AUDITS_V2_FOR_DETAIL_SUCCESS,
                    payload: response,
                });
            })
            .catch((error) => {
                dispatch({
                    type: AUDITS_FAILURE,
                });
            });
    };

export const getAuditSearchKeys =
    ({ projectId }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        return getAuditSearchKeysAPI(stage.id, stage.endpoint, projectId)
            .then((response) => {
                dispatch({
                    type: GET_AUDITS_V2_SEARCH_KEYS_SUCCESS,
                    payload: response,
                });
            })
            .catch((error) => {
                dispatch({
                    type: AUDITS_FAILURE,
                });
            });
    };

export const getRoleActions =
    ({ params }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        return getRoleActionsAPI(stage.endpoint, params)
            .then((response) => {
                dispatch({
                    type: GET_AUDITS_V2_ACTIONS_SUCCESS,
                    payload: response,
                });
            })
            .catch((error) => {
                dispatch({
                    type: AUDITS_FAILURE,
                });
            });
    };
